import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { BoxesPage } from '@/components/Boxes/BoxesPage'
import { boxSearchSchema, withoutSearchDefaults } from '@/components/Boxes/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the page. */
export const Route = createFileRoute('/_app/operations/box-detail/')({
  validateSearch: boxSearchSchema,
  component: BoxesRoute,
})

function BoxesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <BoxesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutSearchDefaults, next, options))
      }
    />
  )
}
